import { render, staticRenderFns } from "./AgentAnnuityPriceList.vue?vue&type=template&id=64f04311&"
import script from "./AgentAnnuityPriceList.vue?vue&type=script&lang=js&"
export * from "./AgentAnnuityPriceList.vue?vue&type=script&lang=js&"
import style0 from "./AgentAnnuityPriceList.vue?vue&type=style&index=0&id=64f04311&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports